






























import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';

@Component
export default class TipologiaservizioFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		name: string = '';
	};

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('tipologiaservizio');
	}

	search() {
		this.advancedSearch.reset();

		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = '';
		this.search();
	}

}
